import { CaretDown } from "@phosphor-icons/react"
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { ScrollArea } from "@/components/ui/scroll-area"
import { cn } from "@/lib/utils"

type SelectType = {
  value: string
  label: string
  disabled?: boolean
}

interface ServiceSelectProps {
  label: string
  options: SelectType[]
  onSelect?(option: SelectType): void
  selectedValue: SelectType
  testId?: string
  disabled?: boolean
}

const ServiceSelect = (props: ServiceSelectProps) => {
  const { label, onSelect, options, selectedValue: selected, testId, disabled = false } = props

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild data-testid={testId} disabled={disabled}>
        <button className="custom-dropdown-trigger bg-surface-subdued relative flex h-12 w-full items-center justify-between gap-2 rounded-md border p-1 pl-4 text-sm">
          <div>
            <label className={cn("absolute top-3.5 left-4 transition-all", selected ? "top-1 text-xs" : "top-3.5")}>
              {label}
            </label>
            <span
              data-testid={`${testId}-selected`}
              className="absolute top-5.25 left-4 w-full truncate pr-12 text-left">
              {selected.label}
            </span>
          </div>
          <div
            className={cn("text-on-surface-subdued flex h-10 w-10 items-center justify-center rounded-3xl", !disabled)}>
            <CaretDown className={cn("h-6 w-6", disabled ? "text-on-surface-disabled" : "text-on-surface-subdued")} />
          </div>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        side="bottom"
        align="start"
        className="grid h-(--radix-select-trigger-height) w-full min-w-(--radix-dropdown-menu-trigger-width) gap-1 rounded-xl">
        <ScrollArea className="max-h-75">
          <div className="py-2">
            {options.map((option) => (
              <div key={option.value} className="text-sm">
                <DropdownMenuCheckboxItem
                  className="data-[state='checked']:bg-primary-surface! data-disabled:text-on-surface-disabled data-[state='checked']:text-on-primary-surface! focus:bg-surface-hovered focus:text-on-surface mx-2 mb-1 transition-all duration-100 data-disabled:pointer-events-none"
                  onSelect={() => {
                    onSelect?.({ value: option.value, label: option.label })
                  }}
                  checked={option.value === selected?.value}
                  disabled={option.disabled}
                  data-testid={`${testId}-${option.value}`}>
                  {option.label}
                </DropdownMenuCheckboxItem>
              </div>
            ))}
          </div>
        </ScrollArea>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export { ServiceSelect }
